import { createSelector } from '@reduxjs/toolkit';
import { currentEmployeeUuid } from './current-employee-uuid';

export const isCurrentUserEmployee = createSelector(currentEmployeeUuid, function (uuid) {
  return uuid !== null && uuid !== undefined && uuid !== '';
});
